import { render, staticRenderFns } from "./data_grid.vue?vue&type=template&id=6cc74cc9&scoped=true&"
import script from "./data_grid.vue?vue&type=script&lang=js&"
export * from "./data_grid.vue?vue&type=script&lang=js&"
import style1 from "./data_grid.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc74cc9",
  null
  
)

export default component.exports